<template>
  <div id="app">
    <TopNavBar class="mb-2"></TopNavBar>

    <!-- dont destroy frontpage when navigating away -->
    <keep-alive v-if="authenticated" include="Main">
      <router-view/>
    </keep-alive>

    <!-- no keep-alive when logged out -->
    <router-view v-else :key="$route.fullPath"></router-view>

  </div>
</template>

<script>
import TopNavBar from './components/TopNavBar'
import axios from 'axios'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      err: null
    }
  },
  components: {
    'TopNavBar': TopNavBar
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated
    })
  },
  methods: {
    ...mapActions('auth', {
      deauthenticate: 'deauthenticateUser'
    }),
    makeErrorToast(statusCode, statusMessage) {
      this.$bvToast.toast(`status ${statusCode}, ${statusMessage}`, {
        title: 'api status response',
        toaster: 'b-toaster-top-right',
        autoHideDelay: 5000,
        appendToast: false
      })
    }
  },
  created() {
    // interceptor that checks for error status codes
    // also checks for redirects (status 301)
    axios.interceptors.response.use(resp => resp, err => {
      if (err.response.status === 303) {
        console.log('intercepted 303 response')
        // this.makeErrorToast(resp.status, resp.statusText)
        this.$router.push({path: err.response.data})
      } else if (err.response.status === 401) {
        console.log("intercepted 401 response")
        this.deauthenticate()
        this.$router.push({path: '/login'})
      } else if (err.response.status === 403) {
        console.log("intercepted 403 response")
        this.$router.go(-1)
      // } else if (!err.status) { // removing for now, seems to trigger even when there is a legitimate 500 error
      //   this.makeErrorToast('NO_STATUS', 'No status response, the server might be down')
      //   this.$router.push({path: `/errornotification/No status response, the server might be down`})
      } else {
        this.makeErrorToast(err.response.status, err.response.statusText)
      }
      // this.makeErrorToast(err.response.status, err.response.statusText)
      // alert('error with status code ' + err.response.status)
      return Promise.reject(err)
    })

  }
}
</script>

<style lang="scss">
// override some of bootstraps defaults
@import './assets/scss/app.scss';
@import '../node_modules/bootstrap/scss/bootstrap';
@import '../node_modules/bootstrap-vue/src/index.scss';

// for background variations on some lists of elements where the odd one will
// have this class
.odd {
  background: lightgray;
}

.trimmed > table.table-bordered > tbody > tr > td {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/App.vue